import React from 'react';
import { Check, MessageCircle } from 'lucide-react';



export function LogoPricing({ phoneNumber }) {
  const packages = [
    {
      name: "Standard Package",
      price: 499,
      description: "Perfect for small businesses and startups",
      features: [
        "2 Initial Logo Concepts",
        "3 Revision Rounds",
        "Vector Source Files",
        "High Resolution Files",
        "Basic Brand Guidelines",
        "Copyright Ownership",
        "5 Day Delivery"
      ]
    },
    {
      name: "Premium Package",
      price: 999,
      description: "Ideal for established businesses",
      features: [
        "4 Initial Logo Concepts",
        "Unlimited Revisions",
        "Vector Source Files",
        "High Resolution Files",
        "Comprehensive Brand Guidelines",
        "Copyright Ownership",
        "Social Media Kit",
        "Business Card Design",
        "3 Day Delivery",
        "Priority Support"
      ]
    }
  ];

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Logo Design Packages</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Choose the package that best suits your needs. All packages include 
            high-quality designs and professional service.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {packages.map((pkg, index) => (
            <div 
              key={index}
              className={`bg-white rounded-2xl shadow-lg overflow-hidden ${
                index === 1 ? 'border-2 border-red-500' : ''
              }`}
            >
              {index === 1 && (
                <div className="bg-red-500 text-white text-center py-2 text-sm font-medium">
                  MOST POPULAR
                </div>
              )}
              <div className="p-8">
                <h3 className="text-2xl font-bold mb-2">{pkg.name}</h3>
                <p className="text-gray-600 mb-4">{pkg.description}</p>
                <div className="flex items-baseline mb-8">
                  <span className="text-4xl font-bold">${pkg.price}</span>
                  <span className="text-gray-500 ml-2">USD</span>
                </div>
                <ul className="space-y-4 mb-8">
                  {pkg.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center">
                      <Check className="h-5 w-5 text-green-500 mr-2" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href={`https://wa.me/${phoneNumber}?text=I'm interested in the ${pkg.name} for logo design.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-full inline-flex items-center justify-center px-6 py-3 rounded-full text-white ${
                    index === 1 ? 'bg-red-500 hover:bg-red-600' : 'bg-gray-800 hover:bg-gray-900'
                  } transition-colors duration-300`}
                >
                  <MessageCircle className="mr-2 h-5 w-5" />
                  Get Started
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

